module.exports = __webpack_public_path__ + "static/keller-2c4f7e862e7eb36230836181b20aed7e.jpg";